export type ImageModel = {
	title: string;
	url: string;
};

export type ImageModelFR = {
	titre: string;
	url: string;
};

export const translateImageModel = (i: ImageModelFR): ImageModel => {
	return {
		title: i.titre,
		url: i.url
	};
};

export const translateImageModelArray = (aI: ImageModelFR[]): ImageModel[] => {
	if (aI) {
		return aI.map((e) => translateImageModel(e));
	}
};
